<template>
	<div class="agree-detail">
		<section class="top-fixing">
			<section class="common-sub-top agree-top container">
				<section class="top-info-wrap">
					<div class="prev-wrap">
						<span class="name-wrap">
							<strong @click="clickClose()" class="close"></strong>
						</span>
					</div>
					<!-- {{ this.$route.params.seqNo }}- {{ this.$route.params.documentCd }} - {{ this.$route.params.documentNm }} -->

					<div class="select-wrap">
						<div class="select-change-off" @click="clickModify">수정</div>
						<div class="select-change-off" @click="clickClose2">삭제</div>
					</div>
					<!-- //선택-->
				</section>
			</section>
		</section>
		<section class="agree-list2 container-fix">
			<ul>
				<li v-for="(item, idx) in items.imageData" :key="idx">
					<div class="img">
						<img v-bind:src="`data:image/gif;base64,${item}`" alt="동의서" />
					</div>
				</li>
			</ul>

			<!-- 삭제 영억-->
			<section class="del-wrap">
				<a class="del_open"></a>
			</section>
			<!-- //삭제 영억-->
		</section>

		<!-- 삭제모달-->
		<section class="del-modal" id="del">
			<div class="alert">선택한 환자동의서를<br />정말 삭제하시겠습니까?</div>
			<div class="btn-group">
				<a class="btn-cancel del_close">취소</a>
				<a @click="deleteDoc()" class="btn-del">삭제</a>
			</div>
		</section>
		<JqueryCommon />
		<JqueryPopup />
	</div>
</template>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>
<script src="https://code.jquery.com/ui/1.12.1/jquery-ui.js"></script>
<script>
import JqueryCommon from '../../components/jquery/JqueryCommon';
import JqueryPopup from '../../components/jquery/JqueryPopup';

export default {
	components: {
		JqueryCommon,
		JqueryPopup
	},
	data: () => ({
		deleteJson: [{ receptNo: '', seqNo: '' }],
		url: '',
		items: {
			documentCd: '',
			endYmd: '',
			imageData: {},
			receiptNo: '',
			seqNo: ''
		},
		selectedInfo: null
	}),
	mounted() {
		this.selectedInfo = this.$route.params.selectedInfo;
		window.receiveAgreeList = this.receiveAgreeList;
		// 스크롤 맨 위로
		window.scrollTo({ top: 0 });

		try {
			var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
			if (varUA.match('android') != null) {
				window.penchart.setStatusBar('black');
			} else if (varUA.indexOf('iphone') > -1 || varUA.indexOf('ipad') > -1 || varUA.indexOf('ipod') > -1) {
				//IOS 일때 처리
				window.webkit.messageHandlers.setStatusBar.postMessage('black');
			}
		} catch (e) {
			alert(e);
		}

		clearInterval(this.$store.state.timerId);
		if ($('#del_wrapper').length > 0) $('#del_wrapper').remove();

		$('#del').popup({
			transition: 'all 0.3s',
			blur: true,
			escape: true,
			scrolllock: true,
			closebutton: false,
			background: true,
			onclose: function () {
				document.body.style.overflow = 'visible';
			}
		});

		try {
			let url = `/agree/viewer/${this.$route.params.receptNo}/${this.$route.params.seqNo}`;
			if (this.$osType === 'web' || this.$osType === 'ios') {
				this.$axios
					.get(url)
					.then(response => {
						this.items = response.data.data;
						console.log('****************');
						console.log(this.items);
					})
					.catch(e => {
						console.log(e);
					});
			} else {
				let result = this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
				this.items = result.data;
			}
		} catch (e) {
			alert(e);
		}
	},
	methods: {
		deleteDoc() {
			$('.btn-cancel').click();
			let url = `/agree`;
			let deleteJson = [
				{
					receptNo: this.$route.params.receptNo,
					seqNo: this.$route.params.seqNo
				}
			];

			if (this.$osType === 'web' || this.$osType === 'ios') {
				this.$axios
					.delete(url, {
						data: { data: deleteJson }
					})
					.then(() => {
						this.clickClose();
					})
					.catch(error => {
						console.log(error);
					});
			} else {
				let apiDeleteData = JSON.stringify({
					url: `${this.$store.state.apiDomain}${url}`,
					param: {
						data: deleteJson
					}
				});

				let result = this.$util.deleteApi(apiDeleteData);
				this.clickClose();
			}
		},
		clickClose() {
			try {
				var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
				if (varUA.match('android') != null) {
					window.penchart.setStatusBar('red');
				} else if (varUA.indexOf('iphone') > -1 || varUA.indexOf('ipad') > -1 || varUA.indexOf('ipod') > -1) {
					//IOS 일때 처리
					window.webkit.messageHandlers.setStatusBar.postMessage('red');
				}
			} catch (e) {
				alert(e);
			}
			this.$router.push({
				name: '환자동의서',
				params: {
					selectedInfo: this.$route.params.selectedInfo
				}
			});
		},
		clickModify() {
			let json = `{"documentCd":"${this.$route.params.documentCd}","documentNm":"${this.$route.params.documentNm}","receptNo":"${this.$route.params.receptNo}","seqNo":"${this.$route.params.seqNo}","entEmpl":"1","ptntNo":"${this.$route.params.selectedInfo.ptntNo}","pageNo":"1","yyyyDate":""}`;
			try {
				var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
				if (varUA.match('android') != null) {
					window.penchart.callDocumentModify(json);
				} else if (varUA.indexOf('iphone') > -1 || varUA.indexOf('ipad') > -1 || varUA.indexOf('ipod') > -1) {
					//IOS 일때 처리
					window.webkit.messageHandlers.callDocumentModify.postMessage(json);
				}
			} catch (e) {
				console.log(e);
				//alert(e);
			}
		},
		async receiveAgreeList(documentCd, ptntNo, pageNo, seqNo, yyyyDate) {
			// try {
			// 	this.$router
			// 		.push({
			// 			name: '환자동의서상세',
			// 			params: {
			// 				documentCd: this.$route.params.documentCd,
			// 				documentNm: this.$route.params.documentNm,
			// 				receptNo: this.$route.params.receptNo,
			// 				seqNo: this.$route.params.seqNo,
			// 				selectedInfo: this.$route.params.selectedInfo
			// 			}
			// 		})
			// 		.catch(e => {
			// 			console.log('catch router ServiceSupportMy dupi');
			// 		});
			// } catch (e) {
			// 	alert(e);
			// }
			try {
				let url = `/agree/viewer/${this.$route.params.receptNo}/${this.$route.params.seqNo}`;
				if (this.$osType === 'web' || this.$osType === 'ios') {
					this.$axios
						.get(url)
						.then(response => {
							this.items = response.data.data;
							console.log('****************');
							console.log(this.items);
						})
						.catch(e => {
							console.log(e);
						});
				} else {
					let result = this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
					this.items = result.data;
				}
			} catch (e) {
				alert(e);
			}
		},
		clickClose2() {
			$('.del_open').click();
		}
	}
};
</script>

<style scoped src="../../assets/css/page/patientAgreeDetail.css"></style>
